import EllipsisDropdownContainer from './EllipsisDropdownContainer';

export default EllipsisDropdownContainer;
